var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"contact-floating-btn",attrs:{"to":"contact"}},[_c('img',{attrs:{"src":require("@/assets/icons/icon-mail.svg"),"alt":""}}),_vm._v(" Contact us ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }